<template>
  <div class="w-100 text-center" style="min-heigth: 100px">
    <div class="imageTemplate h-100" v-if="template.templateId">
      <div class="imageTemplate__actions">
        <CButton v-if="view" color="transparent" class="imageTemplate__button" @click="modal = !modal">View</CButton>
        <CButton v-if="edit" color="transparent" @click="goTo()" class="imageTemplate__button">Edit</CButton>
      </div>
      <img :src="templateImage" :alt="templateName" style="min-heigth: 300px" />
    </div>

    <CModal :title="templateName" color="secundary" :show.sync="modal" size="xl">
      <iframe :src="htmlFileUri" ref="iframeModal" width="100%" height="700px" frameborder="0"></iframe>

      <template #footer>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>
import { DYNAMIC_TEMPLATE_DESTINATION_TYPE } from '@/views/template/constants.js'

export default {
  name: 'imageTemplate',

  props: {
    template: {
      type: Object,
      require: true,
    },
    edit: {
      type: Boolean,
      default: () => false,
      require: true,
    },
    view: {
      type: Boolean,
      default: () => false,
      require: true,
    },
    dynamicDestinationType: {
      type: Number,
    },
  },

  data() {
    return {
      modal: false,
    }
  },

  computed: {
    templateImage() {
      return this.template.thumbnailUri || `${this.$configs.VUE_APP_ROOT_API}template/email/static/${this.template.templateId}/thumbnail.jpg`
    },

    templateName() {
      return this.template.templateName
    },

    htmlFileUri() {
      return this.template.htmlFileUri || `${this.$configs.VUE_APP_ROOT_API}template/email/static/${this.template.templateId}/index.html`
    },

    isDestinationTypeCampaign() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.CAMPAIGN == this.dynamicDestinationType
    },

    isDestinationTypeWorkflow() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.WORKFLOW == this.dynamicDestinationType
    },

    hasDynamicIndex() {
      return this.$route.params.dynamicIndex >= 0
    },
  },

  methods: {
    goTo() {
      const params = {
        contentType: this.template.contentType,
        dynamicDestinationType: this.dynamicDestinationType
      }

      if (this.isDestinationTypeCampaign) {
        params.dynamicId = this.$route.params.campaignId
        params.dynamicIndex = this.template.indexChannel
      }

      if (this.isDestinationTypeWorkflow) {
        params.dynamicId = this.$route.params.workflowId
        params.dynamicIndex = this.template.indexStep
      }

      if (this.template.isUnlayer) {
        params.templateId = this.template.templateId
        this.$router.push({
          name: 'unlayer',
          params,
        })
        return
      }

      params.id = this.template.templateId
      this.$router.push({
        name: 'edit-template-html',
        params,
      })
    },
  },
}
</script>

<style lang="scss">
.imageTemplate {
  position: relative;

  &:hover {
    .imageTemplate__actions {
      cursor: initial;
      background: rgba($primary, 0.1);
      border: 1px solid $primary;
    }

    img,
    p {
      opacity: 0.15;
    }

    .imageTemplate__button {
      opacity: 1;
      color: $primary;
      cursor: pointer;
    }
  }

  &__actions {
    // #ffede7
    background: transparent;
    height: 100%;
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-self: center;
    align-items: center;
    transition: 300ms;
    z-index: 1;
  }

  img {
    transition: 300ms;
  }

  &__button {
    opacity: 0;
    font-family: 14px;
    text-transform: uppercase;
    display: inline-flex;
    transition: 300ms;
  }
}
</style>
